import { BaseService } from './base.service';
import type { User } from '@/types/user';

export interface UpdateUserProfileRequest {
  firstName?: string;
  lastName?: string;
  mobile?: string;
  tag?: string;
  bio?: string;
  experience?: string;
  certifications?: string;
  facebookUrl?: string;
  instagramUrl?: string;
  timezone?: string;
  issueNoticeEmailOptOuts?: ('minor' | 'info')[];
}

/**
 * The signed-in user's own profile.
 *
 * Every route acts on the id in the caller's token — no id is passed from the
 * client — so this works for any authenticated user regardless of role.
 * Managing another admin's record is a different surface entirely
 * (/franchise-admins, gated on FRANCHISES_ADMIN).
 */
export class UserProfileService extends BaseService {
  constructor() {
    super('/user-profile');
  }

  async getProfile(): Promise<User> {
    return this.get<User>('');
  }

  async updateProfile(data: UpdateUserProfileRequest): Promise<User> {
    return this.put<User>('', data);
  }

  async uploadPhoto(file: File): Promise<User> {
    const formData = new FormData();
    formData.append('file', file);
    return this.post<User>('/photo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async removePhoto(): Promise<User> {
    return this.delete<User>('/photo');
  }

  async getPhotoUrl(): Promise<{ url: string }> {
    return this.get<{ url: string }>('/photo/url');
  }
}

export const userProfileService = new UserProfileService();
